import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {CREATE_GROWTH_PATH_ERROR, CREATE_GROWTH_PATH_START, CREATE_GROWTH_PATH_SUCCESS} from "../../types";

export function* create({payload}) {
  try {
    const url = '/growthpath/';
    const method = 'POST';
    const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
    const data = (object) => Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());
    const results = yield call(apiCall, url, method, data(payload.formData), headers);
    yield put({type: CREATE_GROWTH_PATH_SUCCESS, results: results.data});
    yield put(payload.navigate('/app/content-management/manage-growth-path'));
  } catch (error) {
    yield put({type: CREATE_GROWTH_PATH_ERROR, error});
  }
}

export default function* create_growth_path() {
  yield takeLatest(CREATE_GROWTH_PATH_START, create);
}
